( function( $ ) {
	jQuery(document).ready(function($){
		//alert('test1');
		
		/**
		 * Nav Menu handler Function.
		 *
		 */
		
		var WidgethfeNavMenuHandler = function() {
				//return;
			console.log('Nav Menu handler Function 1.');
			var $scope = $('.elementor-widget-avmw-addons');
			var id = 'elementor-accordion-menu';
			//alert(id);
			//var wrapper = $scope.find('.elementor-widget-avmw-nav-menu ');		
			var layout = $('.elementor-widget-avmw-addons .avmw-nav-menu').data('layout');
			var flyout_data = $( '.elementor-widget-avmw-addons .avmw-flyout-wrapper' ).data( 'flyout-class' );
			var last_item = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'last-item' );
			var last_item_flyout = $( '.elementor-widget-avmw-addons .avmw-flyout-wrapper' ).data( 'last-item' );

			var menu_items_links        = $( '.elementor-widget-avmw-addons .avmw-nav-menu nav li a' );
			var menu_items_links_flyout = $( '.elementor-widget-avmw-addons .avmw-flyout-wrapper li a' );
			if (menu_items_links.length > 0) {
				_handle_current_menu_item_class( menu_items_links );
			}

			if (menu_items_links_flyout.length > 0) {
				_handle_current_menu_item_class( menu_items_links_flyout );
			}

			$( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );

			_toggleClick( id );

			_handlePolylangSwitcher( $scope );

			_handleSinglePageMenu( id, layout );

			if( 'horizontal' !== layout ){

				_eventClick( id );
			}else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches ) {

				_eventClick( id );
			}else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {

				_eventClick( id );
			}

			$( '.elementor-widget-avmw-addons .avmw-flyout-trigger .avmw-nav-menu-icon' ).off( 'click keyup' ).on( 'click keyup', function() {

				_openMenu( id );
			} );

			$( '.elementor-widget-avmw-addons .avmw-flyout-close' ).off( 'click keyup' ).on( 'click keyup', function() {

				_closeMenu( id );
			} );

			$( '.elementor-widget-avmw-addons .avmw-flyout-overlay' ).off( 'click' ).on( 'click', function() {

				_closeMenu( id );
			} );	


			$scope.find( '.sub-menu' ).each( function() {

				var parent = $( this ).closest( '.menu-item' );

				$scope.find( parent ).addClass( 'parent-has-child' );
				$scope.find( parent ).removeClass( 'parent-has-no-child' );
			});

			if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
				$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().addClass( 'elementor-button-wrapper' );
				$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).addClass( 'elementor-button' );			
			}

			_borderClass( id );	

			$( window ).on( 'resize', function(){ 

				if( 'horizontal' !== layout ) {

					_eventClick( id );
				}else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches ) {

					_eventClick( id );
				}else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {

					_eventClick( id );
				}

				if( 'horizontal' == layout && window.matchMedia( "( min-width: 977px )" ).matches){

					$( '.elementor-widget-avmw-addons div.avmw-has-submenu-container' ).next().css( 'position', 'absolute');	
				}

				if( 'expandible' == layout || 'flyout' == layout ){

					_toggleClick( id );
				}else if ( 'vertical' == layout || 'horizontal' == layout ) {
					if( window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))){

						_toggleClick( id );					
					}else if ( window.matchMedia( "( max-width: 1024px )" ).matches && $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {
						
						_toggleClick( id );
					}
				}

				_borderClass( id );	

			});

			// Acessibility functions

			$scope.find( '.parent-has-child .avmw-has-submenu-container a').attr( 'aria-haspopup', 'true' );
			$scope.find( '.parent-has-child .avmw-has-submenu-container a').attr( 'aria-expanded', 'false' );

			var hef_navmenu_toggle = $scope.find( '.avmw-nav-menu__toggle' );
			hef_navmenu_toggle.attr( 'aria-haspopup', 'true' );
			hef_navmenu_toggle.attr( 'aria-expanded', 'false' );

			if ( window.matchMedia( "( max-width: 1024px )" ).matches && $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {
				hef_navmenu_toggle.find('i').attr('aria-hidden', 'false');
			}
			if ( window.matchMedia( "( max-width: 768px )" ).matches && $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') ) {
				hef_navmenu_toggle.find('i').attr('aria-hidden', 'false');
			}

			// End of accessibility functions

			$( document ).trigger( 'hfe_nav_menu_init', id );

			$( '.elementor-widget-avmw-addons div.avmw-has-submenu-container' ).on( 'keyup', function(e){

				var $this = $( this );

				if( $this.parent().hasClass( 'menu-active' ) ) {

					$this.parent().removeClass( 'menu-active' );

					$this.parent().next().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
					$this.parent().prev().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );

					$this.parent().next().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );
					$this.parent().prev().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );
				}else { 

					$this.parent().next().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
					$this.parent().prev().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );

					$this.parent().next().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );
					$this.parent().prev().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );

					$this.parent().siblings().find( '.avmw-has-submenu-container a' ).attr( 'aria-expanded', 'false' );

					$this.parent().next().removeClass( 'menu-active' );
					$this.parent().prev().removeClass( 'menu-active' );

					event.preventDefault();

					$this.parent().addClass( 'menu-active' );

					if( 'horizontal' !== layout ){
						$this.addClass( 'sub-menu-active' );	
					}
					
					$this.find( 'a' ).attr( 'aria-expanded', 'true' );

					$this.next().css( { 'visibility': 'visible', 'opacity': '1', 'height': 'auto' } );

					if ( 'horizontal' !== layout ) {
							
						$this.next().css( 'position', 'relative');			
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
											
						$this.next().css( 'position', 'relative');		  					
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {
						
						if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {

							$this.next().css( 'position', 'relative');	
						} else if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-none') ) {
							
							$this.next().css( 'position', 'absolute');	
						}
					}		
				}
			});

			$( '.elementor-widget-avmw-addons li.menu-item' ).on( 'keyup', function(e){
				var $this = $( this );

				$this.next().find( 'a' ).attr( 'aria-expanded', 'false' );
				$this.prev().find( 'a' ).attr( 'aria-expanded', 'false' );
				
				$this.next().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
				$this.prev().find('ul').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
				
				$this.siblings().removeClass( 'menu-active' );
				$this.next().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );
				$this.prev().find( 'div.avmw-has-submenu-container' ).removeClass( 'sub-menu-active' );
					
			});
		};

		function _handle_current_menu_item_class( layout_links ) {
			layout_links.each(
				function () {
					var $this = $( this );
					if ($this.is( '[href*="#"]' )) {
						var menu_item_parent = $this.parent();
						menu_item_parent.removeClass( 'current-menu-item current-menu-ancestor' );
						$this.click(
							function () {
								var current_index  = menu_item_parent.index(),
									parent_element = $this.closest( 'ul' );
								parent_element.find( 'li' ).not( ':eq(' + current_index + ')' ).removeClass( 'current-menu-item current-menu-ancestor' );
								menu_item_parent.addClass( 'current-menu-item current-menu-ancestor' );
							}
						)
					}
				}
			);
		}

		function _openMenu( id ) {

			var flyout_content = $( '#avmw-flyout-content-id-' + id );
			var layout = $( '#avmw-flyout-content-id-' + id ).data( 'layout' );
			var layout_type = $( '#avmw-flyout-content-id-' + id ).data( 'flyout-type' );
			var wrap_width = flyout_content.width() + 'px';
			var container = $( '.elementor-widget-avmw-addons .avmw-flyout-container .avmw-side.avmw-flyout-' + layout );

			$( '.elementor-widget-avmw-addons .avmw-flyout-overlay' ).fadeIn( 100 );

			if( 'left' == layout ) {

				$( 'body' ).css( 'margin-left' , '0' );
				container.css( 'left', '0' );

				if( 'push' == layout_type ) {

					$( 'body' ).addClass( 'avmw-flyout-animating' ).css({ 
						position: 'absolute',
						width: '100%',
						'margin-left' : wrap_width,
						'margin-right' : 'auto'
					});
				}	

				container.addClass( 'avmw-flyout-show' );	
			} else {

				$( 'body' ).css( 'margin-right', '0' );
				container.css( 'right', '0' );

				if( 'push' == layout_type ) {

					$( 'body' ).addClass( 'avmw-flyout-animating' ).css({ 
						position: 'absolute',
						width: '100%',
						'margin-left' : '-' + wrap_width,
						'margin-right' : 'auto',
					});
				}

				container.addClass( 'avmw-flyout-show' );
			}		
		}

		function _closeMenu( id ) {

			var flyout_content = $( '#avmw-flyout-content-id-' + id );
			var layout    = $( '#avmw-flyout-content-id-' + id ).data( 'layout' );
			var wrap_width = flyout_content.width() + 'px';
			var layout_type = $( '#avmw-flyout-content-id-' + id ).data( 'flyout-type' );
			var container = $( '.elementor-widget-avmw-addons .avmw-flyout-container .avmw-side.avmw-flyout-' + layout );

			$( '.elementor-widget-avmw-addons .avmw-flyout-overlay' ).fadeOut( 100 );	

			if( 'left' == layout ) {

				container.css( 'left', '-' + wrap_width );

				if( 'push' == layout_type ) {

					$( 'body' ).css({ 
						position: '',
						'margin-left' : '',
						'margin-right' : '',
					});

					setTimeout( function() {
						$( 'body' ).removeClass( 'avmw-flyout-animating' ).css({ 
							width: '',
						});
					});
				}	

				container.removeClass( 'avmw-flyout-show' );					
			} else {
				container.css( 'right', '-' + wrap_width );
				
				if( 'push' == layout_type ) {

					$( 'body' ).css({
						position: '',
						'margin-right' : '',
						'margin-left' : '',
					});

					setTimeout( function() {
						$( 'body' ).removeClass( 'avmw-flyout-animating' ).css({ 
							width: '',
						});
					});
				}
				container.removeClass( 'avmw-flyout-show' );
			}	
		}

		function _eventClick( id ){

			var layout = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'layout' );

			/*
			$( '.elementor-widget-avmw-addons div.avmw-has-submenu-container' ).off( 'click' ).on( 'click', function( event ) {

				var $this = $( this );

				if( $( '.elementor-widget-avmw-addons nav' ).hasClass( 'avmw-link-redirect-child' ) ) {

					if( $this.hasClass( 'sub-menu-active' ) ) {

						if( ! $this.next().hasClass( 'sub-menu-open' ) ) {

							$this.find( 'a' ).attr( 'aria-expanded', 'false' );

							if( 'horizontal' !== layout ){

								event.preventDefault();

								$this.next().css( 'position', 'relative' );	
							} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
								
								event.preventDefault();

								$this.next().css( 'position', 'relative' );	
							} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches && ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
								
								event.preventDefault();	

								$this.next().css( 'position', 'relative' );	
							}	
						
							$this.removeClass( 'sub-menu-active' );
							$this.nextAll('.sub-menu').removeClass( 'sub-menu-open' );
							$this.nextAll('.sub-menu').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
							$this.nextAll('.sub-menu').css( { 'transition': 'none'} );
						} else{

							$this.find( 'a' ).attr( 'aria-expanded', 'false' );
							
							$this.removeClass( 'sub-menu-active' );
							$this.nextAll('.sub-menu').removeClass( 'sub-menu-open' );
							$this.nextAll('.sub-menu').css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );
							$this.nextAll('.sub-menu').css( { 'transition': 'none'} );

							if ( 'horizontal' !== layout ){

								$this.next().css( 'position', 'relative' );
							} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
								
								$this.next().css( 'position', 'relative' );	
								
							} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches && ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
								
								$this.next().css( 'position', 'absolute' );				
							}	  								
						}		  											
					} else {

						$this.find( 'a' ).attr( 'aria-expanded', 'true' );
						if ( 'horizontal' !== layout ) {
							
							event.preventDefault();
							$this.next().css( 'position', 'relative');			
						} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
							
							event.preventDefault();
							$this.next().css( 'position', 'relative');		  					
						} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {
							event.preventDefault();

							if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {

								$this.next().css( 'position', 'relative');	
							} else if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-none') ) {
								
								$this.next().css( 'position', 'absolute');	
							}
						}	
								
						$this.addClass( 'sub-menu-active' );
						$this.nextAll('.sub-menu').addClass( 'sub-menu-open' );
						$this.nextAll('.sub-menu').css( { 'visibility': 'visible', 'opacity': '1', 'height': 'auto' } );
						$this.nextAll('.sub-menu').css( { 'transition': '0.3s ease'} );
					}
				}
			});
			*/
			
			/*
			$( '.elementor-widget-avmw-addons .avmw-menu-toggle' ).off( 'click keyup' ).on( 'click keyup',function( event ) {

				var $this = $( this );

				if( $this.parent().parent().hasClass( 'menu-active' ) ) {

					event.preventDefault();

					$this.parent().parent().removeClass( 'menu-active' );
					$this.parent().parent().next().css( { 'visibility': 'hidden', 'opacity': '0', 'height': '0' } );

					if ( 'horizontal' !== layout ) {
							
						$this.parent().parent().next().css( 'position', 'relative');			
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
											
						$this.parent().parent().next().css( 'position', 'relative');		  					
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {
						
						if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {

							$this.parent().parent().next().css( 'position', 'relative');	
						} else if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-none') ) {
							
							$this.parent().parent().next().css( 'position', 'absolute');	
						}
					}
				}else { 

					event.preventDefault();

					$this.parent().parent().addClass( 'menu-active' );

					$this.parent().parent().next().css( { 'visibility': 'visible', 'opacity': '1', 'height': 'auto' } );

					if ( 'horizontal' !== layout ) {
							
						$this.parent().parent().next().css( 'position', 'relative');			
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 767px )" ).matches && ($( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile'))) {
											
						$this.parent().parent().next().css( 'position', 'relative');		  					
					} else if ( 'horizontal' === layout && window.matchMedia( "( max-width: 1024px )" ).matches ) {
						
						if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {

							$this.parent().parent().next().css( 'position', 'relative');	
						} else if ( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-none') ) {
							
							$this.parent().parent().next().css( 'position', 'absolute');	
						}
					}		
				}
			});
			*/
			
			$( '.elementor-widget-avmw-addons .avmw-menu-toggle' ).off( 'click keyup' ).on("click keyup", function(e) {
				e.preventDefault();
				var toClose = $(this).parent().next();
				toClose.slideUp();
				toClose.parent().removeClass("open");
				
				if(!$(this).parent().next().is(":visible")) {
					var toOpen = $(this).parent().next();
					toOpen.slideDown();
					toOpen.parent().not(".open").addClass("open");
					
				}  
				e.stopPropagation();
			});
		}

		function _borderClass( id ){

			var last_item = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'last-item' );
			var last_item_flyout = $( '.elementor-widget-avmw-addons .avmw-flyout-wrapper' ).data( 'last-item' );
			var layout = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'layout' );

			$( '.elementor-widget-avmw-addons nav').removeClass('avmw-dropdown');

			if ( window.matchMedia( "( max-width: 767px )" ).matches ) {

				if( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-mobile') || $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet')){
					
					$( '.elementor-widget-avmw-addons nav').addClass('avmw-dropdown');
					if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().removeClass( 'elementor-button-wrapper' );
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).removeClass( 'elementor-button' );	
					}	
				}else{
					
					$( '.elementor-widget-avmw-addons nav').removeClass('avmw-dropdown');
					if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().addClass( 'elementor-button-wrapper' );
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).addClass( 'elementor-button' );	
					}
				}
			}else if ( window.matchMedia( "( max-width: 1024px )" ).matches ) {

				if( $( '.elementor-widget-avmw-addons nav' ).hasClass('avmw-nav-menu__breakpoint-tablet') ) {
					
					$( '.elementor-widget-avmw-addons nav').addClass('avmw-dropdown');
					if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().removeClass( 'elementor-button-wrapper' );
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).removeClass( 'elementor-button' );	
					}
				}else{
					
					$( '.elementor-widget-avmw-addons nav').removeClass('avmw-dropdown');
					if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().addClass( 'elementor-button-wrapper' );
						$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).addClass( 'elementor-button' );
					}
				}
			}else {
				var $parent_element = $( '.elementor-widget-avmw-addons' );
				$parent_element.find( 'nav').removeClass( 'avmw-dropdown' );
				if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
					$parent_element.find( 'li.menu-item:last-child a.avmw-menu-item' ).parent().addClass( 'elementor-button-wrapper' );
					$parent_element.find( 'li.menu-item:last-child a.avmw-menu-item' ).addClass( 'elementor-button' );
				}
			}

			var layout = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'layout' );
			if( 'expandible' == layout ){
				if( ( 'cta' == last_item || 'cta' == last_item_flyout ) && 'expandible' != layout ){
					$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).parent().removeClass( 'elementor-button-wrapper' );
					$( '.elementor-widget-avmw-addons li.menu-item:last-child a.avmw-menu-item' ).removeClass( 'elementor-button' );			
				}			
			}
		}

		function _toggleClick( id ){

			if ( $( '.elementor-widget-avmw-addons .avmw-nav-menu__toggle' ).hasClass( 'avmw-active-menu-full-width' ) ){

				var $toggle = $( '.elementor-widget-avmw-addons .avmw-nav-menu__toggle' );
				var $nextElement= $toggle.next();

				if( $nextElement.length ){
					$nextElement.css( 'left', '0' );
					
					var $section = $( '.elementor-widget-avmw-addons' ).closest('.elementor-section');
					if ( $section.length ) {
						var width = $section.outerWidth();
						var sec_pos = $section.offset().left - $toggle.next().offset().left;
						$nextElement.css( 'width', width + 'px' );
						$nextElement.css( 'left', sec_pos + 'px' );
					}
				}
			}

			$( '.elementor-widget-avmw-addons .avmw-nav-menu__toggle' ).off( 'click keyup' ).on( 'click keyup', function( event ) {

				var $this = $( this );
				var $selector = $this.next();

				if ( $this.hasClass( 'avmw-active-menu' ) ) {
					$('body').removeClass('menu-opened');
                    $('html').removeClass('menu-opened');
					var layout = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'layout' );
					var full_width = $selector.data( 'full-width' );
					var toggle_icon = $( '.elementor-widget-avmw-addons nav' ).data( 'toggle-icon' );

					$( '.elementor-widget-avmw-addons').find( '.avmw-nav-menu-icon' ).html( toggle_icon );

					$this.removeClass( 'avmw-active-menu' );
					$this.attr( 'aria-expanded', 'false' );
					
					if ( 'yes' == full_width ){

						$this.removeClass( 'avmw-active-menu-full-width' );
					
						$selector.css( 'width', 'auto' );
						$selector.css( 'left', '0' );
						$selector.css( 'z-index', '0' );
					}				
				} else {
					$('body').addClass('menu-opened');
                    $('html').addClass('menu-opened');
					var layout = $( '.elementor-widget-avmw-addons .avmw-nav-menu' ).data( 'layout' );
					var full_width = $selector.data( 'full-width' );
					var close_icon = $( '.elementor-widget-avmw-addons nav' ).data( 'close-icon' );

					$( '.elementor-widget-avmw-addons').find( '.avmw-nav-menu-icon' ).html( close_icon );
					
					$this.addClass( 'avmw-active-menu' );
					$this.attr( 'aria-expanded', 'true' );

					if ( 'yes' == full_width ){

						$this.addClass( 'avmw-active-menu-full-width' );

						var closestElement = $( '.elementor-widget-avmw-addons' ).closest('.elementor-section, .e-con-boxed');
						var width = closestElement.outerWidth();
						var sec_pos = closestElement.offset().left - $selector.offset().left;
					
						$selector.css( 'width', width + 'px' );
						$selector.css( 'left', sec_pos + 'px' );
						$selector.css( 'z-index', '9999' );
					}
				}

				if( $( '.elementor-widget-avmw-addons nav' ).hasClass( 'menu-is-active' ) ) {

					$( '.elementor-widget-avmw-addons nav' ).removeClass( 'menu-is-active' );
				}else {

					$( '.elementor-widget-avmw-addons nav' ).addClass( 'menu-is-active' );
				}				
			} );
		}

		function _handleSinglePageMenu( id, layout ) {
			$( '.elementor-widget-avmw-addons ul.avmw-nav-menu li a' ).on(
				'click',
				function () {
					var $this = $( this );
					var link  = $this.attr( 'href' );
					var linkValue = '';
					if ( link.includes( '#' ) ) {
						var index     = link.indexOf( '#' );
						linkValue = link.slice( index + 1 );
					}
					if ( linkValue.length > 0 ) {
						if ( 'expandible' == layout ) {
							$( '.elementor-widget-avmw-addons .avmw-nav-menu__toggle' ).trigger( "click" );
							if ($this.hasClass( 'avmw-sub-menu-item' )) {
								$( '.elementor-widget-avmw-addons .avmw-menu-toggle' ).trigger( "click" );
							}
						} else {
							if ( window.matchMedia( '(max-width: 1024px)' ).matches && ( 'horizontal' == layout || 'vertical' == layout ) ) {
								$( '.elementor-widget-avmw-addons .avmw-nav-menu__toggle' ).trigger( "click" );
								if ($this.hasClass( 'avmw-sub-menu-item' )) {
									$( '.elementor-widget-avmw-addons .avmw-menu-toggle' ).trigger( "click" );
								}
							} else {
								if ($this.hasClass( 'avmw-sub-menu-item' )) {
									_closeMenu( id );
									$( '.elementor-widget-avmw-addons .avmw-menu-toggle' ).trigger( "click" );
								}
								_closeMenu( id );
							}
						}
					}
				}
			);
		}

		/**
		 * This function handles polylang plugin's lang switcher if present in the menu.
		 *
		 * @param {Object} $scope The current element(hfe nav menu) wrapped with jQuery.
		 */
		function _handlePolylangSwitcher( $scope ) {
			var polylangSwitcher = $scope.find( '.avmw-nav-menu nav .pll-parent-menu-item a.avmw-menu-item' );
			var hrefProperty     = polylangSwitcher.prop( 'href' );
			if ( undefined !== hrefProperty && hrefProperty.includes( '#' ) ) {
				var index = hrefProperty.indexOf( '#' );
				var value = hrefProperty.slice( index );
				if ( value === '#pll_switcher' ) {
					polylangSwitcher.prop( 'href', '#' );
				}
			}
		}

        const checkIfMenuLoaded = setInterval(function(){
			if( $('.elementor-widget-avmw-addons').length > 0 ) {
				clearInterval(checkIfMenuLoaded);
				WidgethfeNavMenuHandler();
			}
    	}, 100);
		/*
		$( window ).on( 'elementor/frontend/init', function () {
			console.log('elementor/frontend/init');
			//WidgethfeNavMenuHandler();
			elementorFrontend.hooks.addAction( 'frontend/element_ready/avmw-addons.default', WidgethfeNavMenuHandler );
		});
		*/
		/*
		const checkMenuLoaded = setInterval(function(){
			if( menuLoaded ) {
				console.log(menuLoaded);
				clearInterval(checkMenuLoaded);
			} else {
				console.log(menuLoaded);
				$( window ).on( 'elementor/frontend/init', function () {
					console.log('elementor/frontend/init');
					elementorFrontend.hooks.addAction( 'frontend/element_ready/avmw-addons.default', WidgethfeNavMenuHandler );
				});
			}
		}, 100);
		*/
	})
} )( jQuery );
